import { render } from "./MypageLayout.vue?vue&type=template&id=faccbc9a&scoped=true"
import script from "./MypageLayout.vue?vue&type=script&lang=js"
export * from "./MypageLayout.vue?vue&type=script&lang=js"

import "./MypageLayout.vue?vue&type=style&index=0&id=faccbc9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faccbc9a"]])

export default __exports__